import { gql } from '@apollo/client';

export const CREATE_RESIDENTIAL_MUTATION = gql`
  mutation CreateResidential($residentialCreateDto: ResidentialCreateDto!) {
    createResidential(residentialCreateDto: $residentialCreateDto) {
      id
      institutionName
      email
      createdDt
    }
  }
`;
